import React, { useRef } from "react";
import classes from "../Store.module.scss";
import { useTranslation } from "react-i18next";
import PixIcon from "../../../../assets/images/icon_pix.svg";

interface PaymentCardInfoProps {
  termsCheckBox: boolean;
  setTermsCheckBox: React.Dispatch<React.SetStateAction<boolean>>;
}

const PaymentCardInfo: React.FC<PaymentCardInfoProps> = ({
  termsCheckBox,
  setTermsCheckBox,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classes.CardPaymentInfo}>
      <h2>{t("purchase.payment")}</h2>
      {/* Card do icon do pix */}
      <label className={classes.PixPaymentRadio}>
        <input type="checkbox" checked readOnly />

        <div className={classes.customRadio}></div>

        <div className={classes.PixContent}>
          <img src={PixIcon} alt="" />
          <p>Pix</p>
        </div>
      </label>

      <div className={classes.PixPaymentInfo}>
        <ul>
          <li>{t("purchase.your_pix_payment_code")}</li>
          {/* <li> Para parcelamento do valor total, por favor, selecione a opção Cartão de Crédito como método de pagamento.</li> */}
        </ul>
      </div>
      <div>
        {/* Checkbox do termo */}
        <label className={classes.TermsCheckbox}>
          <input
            type="checkbox"
            id="creditCard"
            name="paymentMethod"
            value="creditCard"
            onClick={() => setTermsCheckBox(!termsCheckBox)}
          />
          <div>
            {t("purchase.terms_and_privacy")}
            <span>
              <a
                href="https://termos.probrain.com.br/pub/terms/terms_2022.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("purchase.terms_of_use")}
              </a>
            </span>{" "}
            {" e "}
            <span>
              <a
                href="https://termos.probrain.com.br/pub/policies/policies_2022.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("purchase.privacy_policy")}
              </a>
            </span>
            .
          </div>
        </label>
      </div>
    </div>
  );
};

export default PaymentCardInfo;
